import axios from 'axios';

export const getCnpj = cnpj => {
  const cnpjClean = cnpj.replace(/[^A-Z0-9]/g, '');
  const validaCnpj = /^[A-Z0-9]{14}$/;

  if (cnpjClean !== '' && validaCnpj.test(cnpjClean)) {
    axios.defaults.headers.common = {};
    return axios
      .get(`https://brasilapi.com.br/api/cnpj/v1/${cnpjClean}`, null)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.error(err);
        return false;
      });
  }

  return false;
};
